import { FormElementNames } from '../lib/formElementMappings'
import { keyValueObject } from '../lib/types'

export const getFormFieldStyle = (elementType: string): keyValueObject => {
  switch (elementType) {
    case 'submit':
      return {
        chakraProps: {
          width: '100%',
          bg: 'primary'
        },
        holderProps: {
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }
      }
    case FormElementNames.element_name:
    case FormElementNames.element_abr:
    case FormElementNames.element_orientation:
    case FormElementNames.orientation:
    case FormElementNames.element:
    case FormElementNames.frl:
    case FormElementNames.is_active:
    case FormElementNames.fixing_required:
    case FormElementNames.is_current:
    case FormElementNames.fire_rated:
    case FormElementNames.is_lagging:
    case FormElementNames.is_email_verified:
    case FormElementNames.display_status:
    case FormElementNames.service_type:
    case FormElementNames.report_standards:
    case FormElementNames.product_notes:
    case FormElementNames.product_instructions:
      return {
        holderProps: {
          width: '100% !important'
        }
      }
    case FormElementNames.frl_st:
    case FormElementNames.frl_integ:
    case FormElementNames.frl_ins:
      return {
        holderProps: {
          width: 'calc(33% - 16px) !important'
        }
      }

    default:
      return {}
  }
}
